<payment-navigation
  [isLoggedIn]="isLoggedIn"
  [user]="user"
  [payment]="payment"
  [ngSwitch]="activatedComponent"
  [transportationMethod]="transportationMethod"
  [voucher]="selectedVoucher"
  (stepper)="handle($event)"
  [address]="address"
  [isLoading$]="loading$"
  [paymentRedirectUrl]="paymentRedirectUrl"
  [activatedComponent]="activatedComponent"
  id="payment-navigation"
>
  <mat-tab-group
    mat-stretch-tabs
    mat-align-tabs="center"
    preserveContent="true"
    animationDuration="100"
    class="payment-container"
    [(selectedIndex)]="selectedTabIndex"
  >
    <mat-tab [disabled]="!!this.payment" label="سبد خرید" id="shoppingCart">
      <shopping-cart-select-orders
        [orders]="shoppingCartOrders"
        (stepper)="handle($event)"
      />
    </mat-tab>

    <!-- Transportation -->
    <mat-tab
      label="روش ارسال"
      id="transformMethod"
      [disabled]="(payment && payment.isFinalized) || !!!payment"
    >
      <payment-transportation
        @stepFadeIn
        (stepper)="handle($event)"
        [orders]="shoppingCartOrders"
        [(address)]="address"
        [transportationMethods]="transportationMethods"
        [(transportationMethod)]="transportationMethod"
      />
    </mat-tab>

    <!-- Payment final factor -->
    <mat-tab
      [disabled]="
        (payment && !(payment.orders && payment.orders.length! > 0)) || !payment
      "
      id="finalPayment"
      label="تایید و پرداخت"
    >
      <payment-final-factor
        @stepFadeIn
        [payment]="payment"
        (stepper)="handle($event)"
        [(voucher)]="selectedVoucher"
        [activatedStep]="activatedComponent"
        [transportMethod]="transportationMethod"
      />
    </mat-tab>
  </mat-tab-group>
</payment-navigation>
